(function() {
  var currentUtterance = null;
  var isInitialized = false;
  
  // Initialize voices on page load
  function initVoices() {
    return new Promise(function(resolve) {
      var voices = speechSynthesis.getVoices();
      if (voices.length > 0) {
        isInitialized = true;
        resolve(voices);
      } else {
        speechSynthesis.addEventListener('voiceschanged', function() {
          voices = speechSynthesis.getVoices();
          isInitialized = true;
          resolve(voices);
        }, { once: true });
        
        // Timeout fallback
        setTimeout(function() {
          if (!isInitialized) {
            voices = speechSynthesis.getVoices();
            isInitialized = true;
            resolve(voices);
          }
        }, 1000);
      }
    });
  }
  
  // Initialize on page load
  if ('speechSynthesis' in window) {
    initVoices();
  }
  
  window.playBlogAudio = function() {
    // Check if Speech Synthesis is supported
    if (!('speechSynthesis' in window)) {
      alert('Sorry, your browser does not support text-to-speech. Please try using Chrome, Safari, or Edge.');
      return;
    }
    
    try {
      var content = document.querySelector('.article-template__content, .rte, [itemprop="articleBody"]');
      if (!content) {
        alert('Content not found. Please try again.');
        return;
      }
      
      var text = content.innerText || content.textContent;
      text = text.trim();
      
      if (!text || text.length < 50) {
        alert('Article text is too short to read.');
        return;
      }
      
      // Limit text length for mobile (some browsers have limits)
      var maxLength = 32000; // Safe limit for most browsers
      if (text.length > maxLength) {
        text = text.substring(0, maxLength) + '...';
      }
      
      // Cancel any ongoing speech
      if (speechSynthesis.speaking) {
        speechSynthesis.cancel();
      }
      
      // Wait for cancel to complete
      setTimeout(function() {
        initVoices().then(function(voices) {
          try {
            currentUtterance = new SpeechSynthesisUtterance(text);
            
            // Set voice parameters
            currentUtterance.rate = 0.9;
            currentUtterance.pitch = 1;
            currentUtterance.volume = 1;
            currentUtterance.lang = 'en-US';
            
            // Select best available voice
            if (voices && voices.length > 0) {
              // Try to find an English voice
              var englishVoice = voices.find(function(voice) {
                return voice.lang.startsWith('en');
              }) || voices[0];
              
              currentUtterance.voice = englishVoice;
            }
            
            // Event handlers
            currentUtterance.onstart = function() {
              console.log('Speech started');
              document.getElementById('play-blog-audio').style.display = 'none';
              document.getElementById('pause-blog-audio').style.display = 'inline-flex';
            };
            
            currentUtterance.onend = function() {
              console.log('Speech ended');
              document.getElementById('play-blog-audio').style.display = 'inline-flex';
              document.getElementById('pause-blog-audio').style.display = 'none';
              currentUtterance = null;
            };
            
            currentUtterance.onerror = function(event) {
              console.error('Speech error:', event);
              document.getElementById('play-blog-audio').style.display = 'inline-flex';
              document.getElementById('pause-blog-audio').style.display = 'none';
              
              var errorMsg = 'Speech playback failed.';
              if (event.error === 'synthesis-failed') {
                errorMsg = 'Audio playback failed. This may be due to browser limitations on mobile devices. Try:\n\n1. Ensuring your device volume is up\n2. Using Chrome or Safari browser\n3. Reloading the page\n4. Checking if text-to-speech is enabled in your device settings';
              } else if (event.error === 'network') {
                errorMsg = 'Network error. Please check your internet connection.';
              } else if (event.error === 'not-allowed') {
                errorMsg = 'Browser blocked audio. Please allow audio in your browser settings.';
              }
              
              alert(errorMsg);
              currentUtterance = null;
            };
            
            // Start speaking
            speechSynthesis.speak(currentUtterance);
            
          } catch(err) {
            console.error('Utterance error:', err);
            alert('Failed to initialize speech: ' + err.message);
            document.getElementById('play-blog-audio').style.display = 'inline-flex';
            document.getElementById('pause-blog-audio').style.display = 'none';
          }
        }).catch(function(err) {
          console.error('Voice initialization error:', err);
          alert('Failed to load voices. Please try again.');
        });
      }, 200);
      
    } catch(e) {
      console.error('Error:', e);
      alert('An unexpected error occurred: ' + e.message);
    }
  };
  
  window.stopBlogAudio = function() {
    if (speechSynthesis.speaking) {
      speechSynthesis.cancel();
    }
    document.getElementById('play-blog-audio').style.display = 'inline-flex';
    document.getElementById('pause-blog-audio').style.display = 'none';
    currentUtterance = null;
  };
  
  // Cleanup on page unload
  window.addEventListener('beforeunload', function() {
    if (speechSynthesis.speaking) {
      speechSynthesis.cancel();
    }
  });
})();